module.exports = __webpack_public_path__ + "static/media/defaultOrangeContainer.d3b18403.svg";